import api from "../../../../services/api";

const getSignature = () => localStorage.getItem("signature");

export interface EmailTemplateCategoryDTO {
  id: number;
  company_id: number;
  company_type: string;
  value: string;
  label: string;
  icon?: string | null;
  color?: string | null;
  is_active: boolean;
  is_default: boolean;
}

export const listCategories = async (
  companyId: string,
  companyType: string,
): Promise<EmailTemplateCategoryDTO[]> => {
  const response = await api.post(
    "emailService/email-template-categories/list",
    {
      signature: getSignature(),
      company_id: companyId,
      company_type: companyType,
    },
  );
  return (response.data?.data as EmailTemplateCategoryDTO[]) || [];
};

export const createCategory = async (
  companyId: string,
  companyType: string,
  payload: { value: string; label: string; icon?: string; color?: string },
) => {
  const response = await api.post(
    "emailService/email-template-categories/create",
    {
      signature: getSignature(),
      company_id: companyId,
      company_type: companyType,
      ...payload,
    },
  );
  return response.data?.data;
};

export const updateCategory = async (
  companyId: string,
  companyType: string,
  categoryId: number,
  payload: {
    label?: string;
    icon?: string;
    color?: string;
    is_active?: boolean;
  },
) => {
  const response = await api.post(
    "emailService/email-template-categories/update",
    {
      signature: getSignature(),
      company_id: companyId,
      company_type: companyType,
      category_id: categoryId,
      ...payload,
    },
  );
  return response.data?.data;
};

export const deleteCategory = async (
  companyId: string,
  companyType: string,
  categoryId: number,
) => {
  const response = await api.post(
    "emailService/email-template-categories/delete",
    {
      signature: getSignature(),
      company_id: companyId,
      company_type: companyType,
      category_id: categoryId,
    },
  );
  return response.data?.data;
};
